import React, { ReactElement } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Trans } from 'react-i18next';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

export interface TileProps {
  title: string;
  description: string;
  icon: string;
  handleClick: () => void;
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      cursor: 'pointer',
      flex: '0 0 30%',
      '&:hover': {
        boxShadow: '0 1px 8px 4px rgba(0, 0, 0, 0.20)',
        transform: 'scale(1.01, 1.01)'
      }
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      alignItems: 'center',
      minHeight: 190,
      textAlign: 'center',
      padding: theme.spacing(2),
      '&:last-child': {
        paddingBottom: theme.spacing(2)
      }
    },
    contentImage: {
      display: 'block',
      width: 'auto',
      height: 80
    },
    contentTitle: {
      marginTop: theme.spacing(2)
    },
    contentDescription: {
      marginTop: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    }
  };
});

const Tile = ({ title, description, icon, handleClick }: TileProps): ReactElement => {
  const classes = useStyles();

  return (
    <Card className={classes.root} onClick={handleClick}>
      <CardContent className={classes.content}>
        <img alt={title} src={icon} className={classes.contentImage} />
        <Typography variant="h3" className={classes.contentTitle}>
          <Trans>{title}</Trans>
        </Typography>
        <Typography variant="body1" className={classes.contentDescription}>
          <Trans>{description}</Trans>
        </Typography>
      </CardContent>
    </Card>
  );
};

export default Tile;
